module.exports = __webpack_public_path__ + "static/media/good.1a919990.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/emojis/good.gif
// module id = 167
// module chunks = 0